var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Tooltip as RmwcTooltip } from '@rmwc/tooltip';
import uuid from 'uuid/v4';
/**
 * Tooltip component. Displays informative text when users hover over, focus on, or tap an element
 *
 *  @see **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/tooltips.md
 *
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.id = uuid();
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props, content = _a.content, props = __rest(_a, ["content"]);
        var updatedContent = (React.createElement("div", { id: this.id }, content));
        return (React.createElement(RmwcTooltip, __assign({ content: updatedContent }, props)));
    };
    return Tooltip;
}(React.Component));
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map